export class AbcSimpleSearch {
	constructor(public searchText: string){

	}
}
